document.addEventListener('DOMContentLoaded', function () {

  // --- Shipping timeline (3 steps) ---
  var timeline = document.getElementById('forza-ship-timeline');
  if (timeline) {
    var minDays = parseInt(timeline.dataset.min || '3', 10);
    var maxDays = parseInt(timeline.dataset.max || '5', 10);
    var months = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];

    function addBusinessDays(date, n) {
      var d = new Date(date);
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }

    function fmt(d) {
      return d.getDate() + ' ' + months[d.getMonth()];
    }

    var today = new Date();
    var readyMin = addBusinessDays(today, 1);
    var readyMax = addBusinessDays(today, 2);
    var delivMin = addBusinessDays(today, minDays);
    var delivMax = addBusinessDays(today, maxDays);

    var d0 = document.getElementById('ship-day0');
    var d1 = document.getElementById('ship-ready');
    var d2 = document.getElementById('ship-delivered');

    if (d0) d0.textContent = fmt(today);
    if (d1) {
      d1.textContent = readyMin.getDate() === readyMax.getDate()
        ? fmt(readyMin)
        : fmt(readyMin) + ' – ' + fmt(readyMax);
    }
    if (d2) {
      d2.textContent = delivMin.getDate() === delivMax.getDate()
        ? fmt(delivMin)
        : fmt(delivMin) + ' – ' + fmt(delivMax);
    }
  }

  // --- Releasit COD button bridge ---
  function findRsiButton() {
    var selectors = [
      '._rsi-cod-form-gempages-button-hook button',
      '._rsi-cod-form-gempages-button-hook a',
      '#_rsi-cod-form-embed-custom-hook button',
      '#_rsi-cod-form-embed-custom-hook a',
      '[class*="rsi-sticky"] button',
      '[class*="rsi-sticky"] a',
      '[class*="rsi-cod-form"] button',
      '[class*="rsi-cod-form"] a',
      '[class*="_rsi"] button',
      '[id*="_rsi"] button',
      '[class*="rsi-cod"] button',
      '[class*="rsi-cod"] a',
      '[class*="releasit"] button',
      '[class*="releasit"] a',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        if (el.classList.contains('forza-cta-fallback')) continue;
        if (el.classList.contains('forza-cta-btn')) continue;
        if (el.closest('.forza-thumbs')) continue;
        return el;
      }
    }
    return null;
  }

  var capturedRsiEl = null;

  function collapseSkelBar() {
    var skel = document.querySelector('body > .rsi-btn-skel, body > [class*="rsi-btn-skel"]');
    if (!skel) return;
    skel.style.setProperty('height', '0', 'important');
    skel.style.setProperty('min-height', '0', 'important');
    skel.style.setProperty('padding', '0', 'important');
    skel.style.setProperty('margin', '0', 'important');
    skel.style.setProperty('overflow', 'hidden', 'important');
    skel.style.setProperty('border', '0', 'important');
  }

  // Watch only the CTA container for the injected button (narrow scope)
  var ctaHook = document.querySelector('.forza-cta-wrap');
  var rsiObserver = new MutationObserver(function () {
    if (capturedRsiEl) { rsiObserver.disconnect(); return; }
    capturedRsiEl = findRsiButton();
    if (capturedRsiEl) {
      rsiObserver.disconnect();
      collapseSkelBar();
    }
  });
  rsiObserver.observe(ctaHook || document.body, { childList: true, subtree: true });

  // Separate shallow observer on body for the Releasit skeleton bar (direct child)
  var skelObserver = new MutationObserver(function () {
    collapseSkelBar();
  });
  skelObserver.observe(document.body, { childList: true });

  [300, 800, 1500, 3000].forEach(function (ms) {
    setTimeout(function () {
      if (!capturedRsiEl) capturedRsiEl = findRsiButton();
      if (capturedRsiEl) collapseSkelBar();
    }, ms);
  });

  function syncBundleToReleasit(qty) {
    if (!window._rsiV2 || typeof window._rsiV2.getState !== 'function') return;
    var state = window._rsiV2.getState();
    var offerGroup = state.quantityOffers && state.quantityOffers[0];
    if (!offerGroup) return;
    var match = null;
    for (var i = 0; i < offerGroup.offers.length; i++) {
      if (offerGroup.offers[i].qty === qty) { match = offerGroup.offers[i]; break; }
    }
    if (!match) return;
    window._rsiV2.setState({
      formValues: {
        quantityOffer: offerGroup.id + '_' + match.pos,
        quantity_offer_expected_qty: String(qty)
      }
    });
  }

  document.querySelectorAll('#forza-bundles input[type="radio"]').forEach(function (r) {
    r.addEventListener('change', function () {
      syncBundleToReleasit(parseInt(this.value, 10));
    });
  });

  function handleCtaClick() {
    document.body.classList.add('forza-rsi-show');
    if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
      var checked = document.querySelector('#forza-bundles input[type="radio"]:checked');
      if (checked) syncBundleToReleasit(parseInt(checked.value, 10));
      window._rsiV2.setState({ isOpen: true });
      return;
    }
    var floatingBar = document.getElementById('floatingBuyNowButton');
    var rsiEl = (floatingBar && floatingBar.querySelector('button, a'))
              || capturedRsiEl
              || findRsiButton();
    if (rsiEl) { rsiEl.click(); }
  }
  document.querySelectorAll('.forza-cta-fallback').forEach(function (btn) {
    btn.addEventListener('click', handleCtaClick);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCtaClick(); }
    });
  });

  // --- Thumbnail gallery + swipe ---
  var mainImg = document.getElementById('forza-main-img');
  var thumbs = Array.from(document.querySelectorAll('.forza-thumb'));

  var counter = document.getElementById('forza-img-counter');

  function activateThumb(thumb) {
    if (mainImg) {
      mainImg.srcset = '';
      mainImg.src = thumb.dataset.src;
    }
    thumbs.forEach(function(b) { b.classList.remove('forza-thumb--active'); });
    thumb.classList.add('forza-thumb--active');
    thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    if (counter) counter.textContent = (thumbs.indexOf(thumb) + 1) + ' / ' + thumbs.length;
  }

  function activeIndex() {
    return thumbs.findIndex(function(t) { return t.classList.contains('forza-thumb--active'); });
  }

  function goTo(index) {
    var i = (index + thumbs.length) % thumbs.length;
    if (thumbs[i]) activateThumb(thumbs[i]);
  }

  // Preload all carousel images immediately so switching is instant
  thumbs.forEach(function(btn) {
    if (btn.dataset.src) {
      var pre = new Image();
      pre.src = btn.dataset.src;
    }
  });

  thumbs.forEach(function(btn) {
    btn.addEventListener('click', function() { activateThumb(this); });
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activateThumb(this); }
    });
  });

  var prevBtn = document.querySelector('.forza-hero__arrow--prev');
  var nextBtn = document.querySelector('.forza-hero__arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(activeIndex() - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(activeIndex() + 1); });

  var imgWrap = document.querySelector('.forza-hero__img-wrap');
  if (imgWrap && thumbs.length > 1) {
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swiping = false;
    imgWrap.addEventListener('touchstart', function(e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });
    imgWrap.addEventListener('touchmove', function(e) {
      if (!swiping) return;
    }, { passive: true });
    imgWrap.addEventListener('touchend', function(e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        goTo(activeIndex() + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  // --- FAQ Accordion ---
  document.querySelectorAll('.forza-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.forza-faq__item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.forza-faq__item.open').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // --- Add to Cart (fallback when Releasit not captured) ---
  document.querySelectorAll('[data-forza-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (capturedRsiEl) return;
      var variantId = this.dataset.variantId;
      if (!variantId || variantId === 'null' || variantId === '') {
        alert('Configura el Variant ID en los ajustes de la sección.');
        return;
      }
      var original = btn.textContent;
      btn.textContent = 'Agregando...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status === 422 || data.description) throw new Error(data.description);
          window.location.href = '/cart';
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
          alert('Error al agregar. Intenta de nuevo.');
        });
    });
  });

  // --- Scroll fade-in animations (IntersectionObserver) ---
  function initScrollAnim(el, delay) {
    if (!('IntersectionObserver' in window)) {
      el.classList.add('forza-visible');
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        setTimeout(function () {
          entry.target.classList.add('forza-visible');
          if (entry.target.hasAttribute('data-counter')) animateCounter(entry.target);
        }, delay || 0);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    obs.observe(el);
  }

  // Wire up explicit [data-counter] + .forza-animate elements (stats)
  document.querySelectorAll('.forza-animate').forEach(function (el, i) {
    initScrollAnim(el, i * 80);
  });

  // Auto-animate section titles, tags, subtitles that aren't already marked
  document.querySelectorAll('.forza-section__tag, .forza-section__title, .forza-section__subtitle').forEach(function (el) {
    if (!el.classList.contains('forza-animate')) {
      el.classList.add('forza-animate');
      initScrollAnim(el, 0);
    }
  });

  // --- Animated number counter ---
  function animateCounter(el) {
    var raw = (el.dataset.target || el.textContent).trim();
    var prefix = raw.match(/^[^\d]*/)[0];
    var suffix = raw.match(/[^\d]*$/)[0];
    var target = parseFloat(raw.replace(/[^\d.]/g, ''));
    if (isNaN(target)) return;

    var duration = 1400;
    var startTime = null;

    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      el.textContent = prefix + Math.round(easeOut(progress) * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // --- Releasit sticky bar — scroll-controlled via display ---
  (function() {
    var s = document.createElement('style');
    s.textContent =
      'body:not(.forza-rsi-show) #floatingBuyNowButton{display:none!important}' +
      'body.forza-rsi-show #floatingBuyNowButton{display:flex!important;flex-direction:column!important;opacity:1!important;visibility:visible!important;transform:translateY(0)!important;bottom:0!important;left:0!important;right:0!important;width:100%!important;margin:0!important;padding:0!important;overflow:hidden!important;pointer-events:auto!important}' +
      '@media(min-width:1100px){body.forza-rsi-show #floatingBuyNowButton{opacity:0!important;pointer-events:none!important}}';
    document.body.appendChild(s);
  })();

  var ctaWrap = document.querySelector('.forza-cta-wrap');
  var ctaWrapVisible = true;

  // El IntersectionObserver de abajo dispara MIENTRAS la pagina se esta armando: en ese
  // momento el CTA todavia no esta donde va a quedar, `isIntersecting` da false y la barra
  // flotante se muestra. Cuando el hero termina de cargar y el layout se acomoda, el CTA entra
  // en pantalla y la barra se apaga sola. Ese ida y vuelta de ~900ms es el destello que se veia
  // en cada carga (solo en Safari; en Chromium no se reproduce).
  //
  // La barra no decide nada hasta que la pagina termino de cargar o el cliente scrolleo.
  // `fz-barra-lista` en <html> es lo que ademas destraba el CSS del <head>, que la mantiene
  // oculta antes de eso — sin el, ya habria pintado para cuando este JS corre.
  var barraLista = false;
  function habilitarBarra() {
    if (barraLista) return;
    barraLista = true;
    try { document.documentElement.classList.add('fz-barra-lista'); } catch (e) {}
    updateRsiBar();
  }

  function updateRsiBar() {
    // Antes de estar lista NUNCA se muestra: es la decision temprana la que estaba mal.
    if (!barraLista) { document.body.classList.remove('forza-rsi-show'); return; }
    if (window.innerWidth >= 1100) {
      document.body.classList.add('forza-rsi-show');
      return;
    }
    document.body.classList.toggle('forza-rsi-show', !ctaWrapVisible);
  }

  // SE DESTRABA CON EL SCROLL, no con `load`. Probado: al terminar de cargar el CTA ya quedo
  // fuera de vista (el contenido de arriba lo empuja), asi que habilitar en `load` deja la
  // barra encendida apenas abris la pagina — peor que el destello original.
  // 80px y no 0 para que un rebote de scroll al cargar no cuente como "el cliente bajo".
  function alScrollear() {
    if (window.scrollY > 80) {
      window.removeEventListener('scroll', alScrollear);
      habilitarBarra();
    }
  }
  window.addEventListener('scroll', alScrollear, { passive: true });
  // Si la pagina abre ya scrolleada (volver atras, un ancla) no hay que esperar un scroll.
  alScrollear();

  if (ctaWrap && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      ctaWrapVisible = entries[0].isIntersecting;
      updateRsiBar();
    }, { threshold: 0 }).observe(ctaWrap);
  } else {
    // Fallback for old browsers: measure once on load only
    ctaWrapVisible = !ctaWrap || ctaWrap.getBoundingClientRect().bottom >= 0;
  }

  updateRsiBar();
  window.addEventListener('resize', updateRsiBar, { passive: true });

  // --- "Cómo Funciona" steps carousel (scroll-snap) ---
  (function () {
    var track = document.getElementById('forza-hiw-track');
    if (!track) return;
    var dots = Array.from(document.querySelectorAll('#forza-hiw-dots .forza-hiw-dot'));
    var slides = Array.from(track.querySelectorAll('.forza-hiw-carousel__slide'));

    function isMobile() { return window.innerWidth < 768; }

    function slideStep() {
      return slides[0] ? slides[0].offsetWidth + 12 : track.offsetWidth;
    }

    function goTo(n) {
      if (!isMobile()) return;
      track.scrollTo({ left: n * slideStep(), behavior: 'smooth' });
    }

    function updateDots() {
      var active = Math.round(track.scrollLeft / slideStep());
      dots.forEach(function (d, i) { d.classList.toggle('forza-hiw-dot--active', i === active); });
    }

    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    track.addEventListener('scroll', updateDots, { passive: true });
  })();

  // --- Touch-to-pause reviews carousel ---
  var reviewsTrack = document.querySelector('.forza-reviews__track');
  if (reviewsTrack) {
    var resumeTimer = null;

    reviewsTrack.parentElement.addEventListener('touchstart', function () {
      clearTimeout(resumeTimer);
      reviewsTrack.classList.add('forza-paused');
    }, { passive: true });

    reviewsTrack.parentElement.addEventListener('touchend', function () {
      resumeTimer = setTimeout(function () {
        reviewsTrack.classList.remove('forza-paused');
      }, 3000);
    }, { passive: true });
  }

});
